import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const AIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        stroke="#E6E617"
        strokeWidth={0.4}
        d="M14.779 6.217c.063 1.179.082 2.312-.146 3.162-.118.443-.3.791-.56 1.028-.255.233-.606.375-1.098.375-.502 0-.841-.118-1.079-.315-.24-.2-.402-.5-.507-.914-.105-.414-.148-.925-.165-1.525-.015-.545-.007-1.15-.006-1.811h3.56Z"
      />
      <Path
        fill="#82E5FF"
        fillRule="evenodd"
        d="M11.397 10.157c.298.667.821 1 1.568 1 .742 0 1.266-.329 1.574-.987l-3.142-.013Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E18600"
        d="M12.928 6.6c.664 0 1.205.537 1.205 1.2 0 .664-.54 1.2-1.205 1.2a1.203 1.203 0 0 1-1.206-1.2c0-.663.54-1.2 1.206-1.2Zm0 .5a.703.703 0 0 0-.706.7c0 .387.316.7.706.7.389 0 .705-.313.705-.7 0-.386-.316-.7-.705-.7Z"
      />
      <Path
        fill="#E18600"
        fillRule="evenodd"
        d="M12.724 6.433s-.438.199-.343.573c.095.374.203.427.203.427s.154-.81.78-.81l-.64-.19ZM11.926 8.45s.366.313.664.069c.299-.245.302-.365.302-.365s-.8.202-1.064-.365l.098.66ZM14.12 8.407s.014-.481-.364-.56c-.378-.078-.473-.004-.473-.004s.66.494.386 1.056l.451-.492Z"
        clipRule="evenodd"
      />
      <G clipPath="url(#b)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.869L8.245.945 9.29-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.505 9.436-8.08H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346l2.118-.29 3.29 2.768 2.649 1.865L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.937-1.01.504-4.018-3.46-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.972Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
